import { IPoint } from '@/utils/gis/types';

export function getPointFromMouseEvent(event: google.maps.MapMouseEvent): IPoint | undefined {
  if (event.latLng === null) {
    return undefined;
  }
  return [event.latLng.lng(), event.latLng.lat()];
}
